import React, { FC, ReactElement } from 'react'

import { Page } from '../../components'
import { ConnectedLeaveOfAbsenceDetail } from '../../connectors'

const AbsenceDetailPage: FC = (): ReactElement => (
    <Page className="absence-detail-page">
        <ConnectedLeaveOfAbsenceDetail />
    </Page>
)

export default AbsenceDetailPage
